/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit AddAction/view.blocks to change it.
import * as fromFlow from 'Simple/Flow'
import React from 'react'
import TysiaButtonWithText from 'DesignSystem/TysiaButtonWithText/index'



/** @type {import('Simple/types.js').View} */
export default function AddAction({
  children,
  viewPath = "/App/Account/Content/Settings/Content/DocumentTemplates/Templates/AddAction"
  
}) {
  let flow = fromFlow.useFlow()
  let setFlowTo = fromFlow.useSetFlowTo(viewPath)
  return (<React.Fragment
>
<TysiaButtonWithText
  viewPath={`${viewPath}/TysiaButtonWithText`}
 text="Add new"
 onClick={() => setFlowTo(fromFlow.normalizePath(viewPath, '../../Template'))}
 isSelected={flow.has(fromFlow.normalizePath(viewPath, '../../Template'))}
/>
{children}
</React.Fragment>)
}